import actionTypes from '../../actions/actionTypes';
export const initialState = { alert: null };

export default function (state = initialState, action) {
  const { type, alert } = action;

  if (type === actionTypes.ALERT_UNSET) return initialState;
  if (!!alert) return { alert };
  return state;
}



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/appState/alert.js